import React from "react"
// import Footer from "components/navigation/app/Footer"
import Header from "components/navigation/app/Header"

const PageWrapper = ({ children }) => {
    return (
        <div className="h-screen flex flex-col">
            <Header />
            <div className="pt-16 flex-1 h-full">{children}</div>
        </div>
    )
}

export default PageWrapper
